<template>
    <div id="main-header">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <header class="col-12 float-left">
            <div class="row">

                <div class="header-logo col-5 col-sm-6 col-md-4 col-lg-2 float-left">
                    <div class="row">
                        <div class="logo-left">
                            <router-link v-bind:to="{ path:'/'}"><img src="/static/images/vvg-home-logo.png" alt="Velocity Truck Center"> </router-link>
                        </div>
                    </div>
                </div>

                <div class="middle-menu col-6 col-sm-6 col-md-7 col-lg-7 float-left">
                    <div class="row">
                        <i class="fa fa-close"></i>
                        <ul class="snip1135">
                            <li> <router-link v-bind:to="{ path:'/ourstory'}" data-hover="Our Story" title="Our Story"> Our Story </router-link> </li>
                            <!--<li> <router-link v-bind:to="{ path:'/hrcalendar'}" data-hover="HR Calendar"> HR Calendar </router-link> </li>-->
                            <li> <router-link v-bind:to="{ path:'/benefits'}" data-hover="Benefits" title="Benefits"> Benefits </router-link> </li>
                            <li> <router-link v-bind:to="{ path:'/401kplan'}" data-hover="401K" title="401K"> 401K </router-link> </li>
                            <li> <router-link v-bind:to="{ path:'/day-force-101'}" data-hover="Dayforce 101" title="Dayforce 101"> Dayforce 101 </router-link> </li>
                            <li> <router-link v-bind:to="{ path:'/formspolicies'}" data-hover="Policies and Forms" title="Policies and Forms"> Policies and Forms </router-link> </li>
                            <li> <router-link v-bind:to="{ path:'/faq'}" data-hover="FAQs" title="FAQs"> FAQs </router-link> </li>
                            <li> <a :href="safetyURL" target="_blank" data-hover="Safety Zone" title="Safety Zone"> Safety Zone </a> </li>
                            <!--<li> <router-link v-bind:to="{ path:'/employeeperksprogram'}" data-hover="Employee Perks"> Employee Perks  </router-link> </li>
                            <li> <router-link v-bind:to="{ path:'/employeerecognition'}" data-hover="Employee Recognition"> Employee Recognition </router-link> </li>-->
                            <!-- <li> <a href="#" data-hover="Contact info"> Contact info </a> </li>  -->
                        </ul>
                    </div>
                </div>

                <div class="my-account-name col-5 col-sm-6 col-md-6 col-lg-2 float-left">
                    <template v-if="roleId <= 2 || userPermissions.indexOf('add_contact_extension') > -1 || userPermissions.indexOf('allow_user_management_module') > -1">
                        <!--<template v-if="roleId == 1">-->
                        <template v-if="roleId > 1 && (userPermissions.indexOf('add_contact_extension') > -1 || userPermissions.indexOf('allow_user_management_module') > -1)">
                          <template v-if="(userPermissions.indexOf('add_contact_extension') > -1 || userPermissions.indexOf('allow_user_management_module') > -1)">
                            <router-link v-bind:to="{name: userPermissions.indexOf('allow_user_management_module') > -1 ? 'ListUser' : 'ListContact'}" class="ac-left-des" title="My Account"> <i class="hi-icon hr-user"> </i> <p>My Account </p>  </router-link>
                          </template>
                        </template>

                        <template v-else-if="roleId == 2">
                           <router-link v-bind:to="{name: 'ListTalentProfile'}" class="ac-left-des" title="My Account"> <i class="hi-icon hr-user"> </i> <p>My Account </p>  </router-link>
                         </template>
                        <!-- <template v-if="roleId > 1 && ">
                            <router-link v-bind:to="{name: ''}" class="ac-left-des"> <i class="hi-icon hr-user"> </i> <p>My Account </p>  </router-link>
                        </template> -->
                        <template v-else>
                            <router-link v-bind:to="{name: 'ListBenefits'}" class="ac-left-des" title="My Account"> <i class="hi-icon hr-user"> </i> <p>My Account </p>  </router-link>
                        </template>
                    </template>
                    <template v-else>
                        <!--<div class="ac-left-des">&nbsp;</div>
                        <router-link v-bind:to="{ path:'/'}" class="ac-left-des"> <i class="hi-icon hr-user"> </i> <p>My Account </p>  </router-link>-->
                    </template>
                    <!--<a href='#' v-bind:to="{ path:'/admin/listbenefits'}"> <i class="hi-icon hr-user"> </i> <p>My Account </p> </a>-->
                    <div class="home-email-icon">
                        <router-link v-bind:to="{ path:'/contact'}" title="Contact HR">
                            <i class="hi-icon hr-email"> </i>
                        </router-link>
                    </div>
                    <template v-if="userPermissions.indexOf('access_social_media_calendar') > -1">
                        <div class="home-email-icon">
                            <router-link v-bind:to="{name: 'SocialMediaCalendar'}" title="Social Media Calendar">
                                <i class="fa fa-calendar"> </i>
                            </router-link>
                        </div>
                    </template>
                    <button type="button" class="home-responsive-menu-right">
                        <i class="hi-icon hr-menu"> </i>
                    </button>
                </div>

                <div class="home-menu-right col-2 col-sm-6 col-md-2 col-lg-1 float-left">
                    <div class="button_container" id="toggle" v-on:click="menuToggle">
                        <span class="top"></span>
                        <span class="middle"></span>
                        <span class="bottom"></span>
                    </div>

                    <div class="overlay" id="overlay">
                        <nav class="overlay-menu">
                            <div class="container">

                                <div class="menu-hover-full col-12 float-l">
                                    <ul class="snip1135 float-l width-full">
                                        <!--<li><a href="meet-hr-team.html" data-hover="About Us">About Us</a></li>-->
                                        <li><router-link v-bind:to="{ path:'/meethrteam'}" data-hover="Meet the HR Team">Meet the HR Team</router-link></li>
                                        <li><router-link v-bind:to="{ path:'/ourstory'}" data-hover="Our Story">Our Story</router-link></li>
                                        <li><router-link v-bind:to="{ path:'/hrcalendar'}" data-hover="HR Calendar">HR Calendar</router-link></li>
                                        <template v-if="userPermissions.indexOf('access_social_media_calendar') > -1">
                                            <li><router-link v-bind:to="{name: 'SocialMediaCalendar'}" data-hover="Social Media Calendar">Social Media Calendar</router-link></li>
                                        </template>
                                        <!--<li><a href="#" data-hover="HR Hot Line reporting">HR Hot Line reporting</a></li>-->
                                        <template v-if="roleId <= 2">
                                            <li><router-link v-bind:to="{ path:'/leadershipdevelopment'}" data-hover="Leadership and Development">Leadership and Development</router-link></li>
                                        </template>
                                        <li><router-link to="/benefits" data-hover="Benefits"> Benefits </router-link></li>
                                        <li><router-link v-bind:to="{ path:'/wellness'}" data-hover="Wellness">Wellness</router-link></li>
                                        <li><router-link v-bind:to="{ path:'/employeerecognition'}" data-hover="Employee Recognition">Employee Recognition</router-link></li>
                                        <li><router-link v-bind:to="{ path:'/formspolicies'}" data-hover="Policies and Forms">Policies and Forms</router-link></li>
                                        <li><router-link v-bind:to="{ path:'/employeeperksprogram'}" data-hover="Employee Perks">Employee Perks</router-link></li>

                                        <li><router-link v-bind:to="{ path:'/surveys'}" data-hover="Surveys">Surveys</router-link></li>
                                        <li><router-link v-bind:to="{ path:'/gallery'}" data-hover="Photo Gallery">Photo Gallery</router-link></li>
                                        <!--<li><a href="#" data-hover="Video Library">Video Library</a></li> -->
                                        <li><router-link v-bind:to="{ path:'/day-force-101'}" data-hover="Dayforce 101">Dayforce 101</router-link></li>
                                        <li><router-link v-bind:to="{ path:'/401kplan'}" data-hover="401K">401K</router-link></li>
                                        <li><router-link v-bind:to="{ path:'/faq'}" data-hover="FAQs">FAQs</router-link></li>
                                        <li><a :href="safetyURL" target="_blank" data-hover="Safety Zone">Safety Zone</a></li>
                                        <li><router-link v-bind:to="{ name:'ViewLocationDepartments',params:{slug : extension_slug}}" data-hover="Extension Directory">Extension Directory</router-link></li>
                                        <li><router-link v-bind:to="{ path:'/contact'}" data-hover="Contact">Contact</router-link></li>
                                        <li><router-link v-bind:to="{ path:'/forum'}" data-hover="Forum">Forum</router-link></li>
                                        <template v-if="roleId <= 2">
                                            <li><router-link v-bind:to="{ path:'/managertoolbox'}" data-hover="Manager Tool Box">Manager Tool Box</router-link></li>
                                        </template>
                                        <li><a href="javascript:void(0)" v-on:click.prevent="logout()" data-hover="Log Out">Log Out</a></li>
                                    </ul>
                                </div>

                                <!--<div class="menu-hover-full col-12 col-md-4 col-sm-4">
                                    <ul class="snip1135">
                                        <li><a href="meet-hr-team.html" data-hover="About Us">About Us</a></li>
                                        <li><a href="meet-hr-team.html" data-hover="Meet the HR Team">Meet the HR Team</a></li>
                                        <li><a href="#" data-hover="HR Calendar">HR Calendar</a></li>
                                        <li><a href="#" data-hover="HR Hot Line reporting">HR Hot Line reporting</a></li>
                                        <li><a href="leadership-development.html" data-hover="Leadership and Development">Leadership and Development</a></li>
                                    </ul>
                                </div>

                                <div class="menu-hover-full col-12 col-md-4 col-sm-4">
                                    <ul class="snip1135">
                                        <li ><router-link to="/benefits"><a href="javascript:void(0)" data-hover="Benefits">Benefits</a></router-link></li>
                                        <li><a href="wellness.html" data-hover="Wellness">Wellness</a></li>
                                        <li><a href="employee-recognition.html" data-hover="Employee Recognition">Employee Recognition</a></li>
                                        <li><a href="forms-policies.html" data-hover="Policies/ Forms">Policies/ Forms</a></li>
                                        <li><a href="employee-perks-program.html" data-hover="Employee Perks">Employee Perks</a></li>
                                    </ul>
                                </div>

                                <div class="menu-hover-full col-12 col-md-4 col-sm-4">
                                    <ul class="snip1135">
                                        <li ><a href="#" data-hover="Surveys">Surveys</a></li>
                                        <li><a href="gallery.html" data-hover="Photo Gallery">Photo Gallery</a></li>
                                        <li><a href="#" data-hover="Video Library">Video Library</a></li>
                                        <li><a href="day-force-101.html" data-hover="Dayforce 101">Dayforce 101</a></li>
                                        <li><a href="401k-plan.html" data-hover="401K">401K</a></li>
                                        <li><a href="javascript:void(0)" v-on:click.prevent="logout()" data-hover="Log Out">Log Out</a></li>
                                    </ul>
                                </div>-->
                            </div>
                        </nav>
                    </div>


                    <!-- <div class="site-header-collapsed">
                    <div class="site-header-collapsed-in">
                        <ul class="cl-effect-15" id="cl-effect-15">
                          <li> <a href="#" data-hover="Wellness"> Wellness </a> </li>
                          <li> <a href="#" data-hover="Policies"> Policies </a> </li>
                          <li> <a href="#" data-hover="HR Calendar"> HR Calendar </a> </li>
                          <li> <a href="#" data-hover="Gallery"> Gallery </a> </li>
                          <li> <a href="#" data-hover="Contact info"> Contact info </a> </li>
                        </ul>
                    </div>
                    </div> -->

                </div>



            </div>
        </header>
        <a href="#" id="scroll" title="Scroll to Top" style="display: none;">Top<span></span></a>
    </div>
</template>
<script>
    import index from "../../router";
    import EventBus from "../event-bus";
    import Vue from "vue";
    import SessioMixin from '../../mixins/sessionmixin';
    import {HTTP} from '../../http-common';
    var self;
    export default {
        /*import * as mykey from '/static/js/jquery.rotateSlider.js',*/
        name: "Home",
        mixins: [SessioMixin],
        data() {
            return {
                safetyURL: "",
                extension_slug: '',
                isLoggedIn: false,
                isShowLoggedinfields: true,
                loginID: 0,
                userPermissions: [],
                roleId: 0,
                roleName: 0,
                system_year: '',
            };
        },
        beforeMount: function () {
            self = this;
            var check = window.localStorage.getItem("api_token");

            if (check != null) {
                self.isLoggedIn = true;
                self.getPermissions();
                /*console.log(self.isLoggedIn);*/
            }
        },
        mounted: function () {
            self.safetyURL = process.env.SAFETY_URL;
            self.safetyURL = self.safetyURL + "login?token=" + localStorage.getItem("api_token");
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    $('#scroll').fadeIn();
                } else {
                    $('#scroll').fadeOut();
                }
            });
            $('#scroll').click(function () {
                $("html, body").animate({
                    scrollTop: 0
                }, 600);
                return false;
            });
            $('.home-responsive-menu-right').click(function () {
                $('.middle-menu').addClass("menu-toggle")
            });

            $('.fa-close').click(function () {
                $('.middle-menu').removeClass("menu-toggle")
            });
            $('#main-header').show();
            $('#main-footer').show();
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
            }
        },
        methods: {
            menuToggle: function () {
                $('#toggle').toggleClass('active');
                $('#overlay').toggleClass('open');
            },
        }
    };
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.roleName = name;
            self.system_year = system_year;
            self.userPermissions = userPermissions;
        }
    });
    EventBus.$on('contact', function (isLogin, company,safetyLink) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.extension_slug = company;
            self.safetyURL = process.env.SAFETY_URL;
            self.safetyURL = self.safetyURL + "login?token=" + safetyLink;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/partials/Header.vue